import { getAugmentedNamespace as e } from "./_commonjsHelpers.js";
import * as r from "../node_modules/@mui/utils/esm/capitalize/index.js";
const m = /* @__PURE__ */ e(r);
export {
  m as default
};
